import React from 'react';
import { FileText, ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { legislativeReferences } from '../data/mock';

const LegislativeSection = () => {
  return (
    <section id="normative" className="py-24 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-slate-200 text-slate-700 rounded-full text-sm font-semibold mb-4">
            <FileText className="inline-block mr-2" size={16} />
            Riferimenti Legislativi
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            Normative e Regolamenti
          </h2>
          <p className="text-lg text-slate-600">
            La pulizia e la manutenzione dei sistemi HVAC sono obblighi legali per le aziende. 
            Ecco i principali riferimenti normativi.
          </p>
        </div>

        {/* Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {legislativeReferences.map((ref, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white rounded-xl shadow-md border-0 overflow-hidden"
              >
                <AccordionTrigger className="px-6 py-5 text-left hover:no-underline hover:bg-slate-50 [&[data-state=open]]:bg-sky-50">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <FileText className="w-5 h-5 text-sky-600" />
                    </div>
                    <span className="font-semibold text-slate-800">{ref.title}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5">
                  <div className="pl-14 text-slate-600 leading-relaxed">
                    {ref.description}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional Info */}
        <div className="mt-12 max-w-3xl mx-auto">
          <div className="p-6 bg-amber-50 border border-amber-200 rounded-xl">
            <p className="text-amber-800">
              <strong>Importante:</strong> Rispettare le normative come il Decreto Legislativo 81/08 
              è fondamentale per evitare sanzioni legali e garantire la sicurezza dei lavoratori. 
              La nostra certificazione AIISA garantisce che i nostri interventi siano conformi ai più alti standard legislativi.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegislativeSection;
